import Framework, { BaseService } from '@greenville/framework';
import _ from 'lodash';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class AIChartsDetailsUtilityService extends BaseService {
  constructor() {
    super(constants.GET_AI_CHARTS_UTILITY_LIST_DATA, 'aiFeedbackChartsDetailsListService');
  }

  handleEvent(eventName, event) {
    const payload = _.omit(event.payload, ['tenantId']);
    let headers = event.payload.tenantId ? { 'x-berlin-tenant-id': event.payload.tenantId } : {};
    headers = Object.keys(headers).length > 0 ? headers : undefined;
    return this.getClient('evergreen').post(`/chartsutility/feedbackdetails`, payload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success' && data?.data?.length > 0) {
      const notification = {
        open: true,
        type: 'success',
        message: 'Data Fetched successfully'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('aiFeedbackChartsDetails').setResponse(response.data);
    } else {
      const notification = {
        open: true,
        type: 'error',
        message: 'No Data Found'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('aiFeedbackChartsDetails').setResponse(response.data);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getStoreRegistry().getStore('aiFeedbackChartsDetails').resetStoreValues();
  }
}
